import React, { Fragment, PureComponent } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import { reset } from 'redux-form';

import { Button, ButtonSet, TableActionIcon, TableCell, TableRow, Text } from '../../../core/components/styled';
import confirm from '../../../core/services/confirm';
import { createErrorNotification, createSuccessNotification } from '../../../core/services/createNotification';
import translate from '../../../core/services/translate';
import { PaymentInfoFillIcon, PaymentInfoFillIconPopUpOpen } from '../../../opportunity/components/styled';
import { AcceptRecurringServicesModal, DetailsWorkOrderRateModal } from '../modal';
import isFalsy from '../../../utils/services/isFalsy';
import { getQueryParams } from '../../../utils/services/queryParams';
import { currentVendorIdSelector } from '../../../vendors/services/currentVendorSelector';
import { LIMIT_PER_PAGE } from '../../constants';
import {
  updateIssueReportRecurringServices,
  updateRecurringServices,
  updateUndoAcceptRecurringServices,
  updateUndoReportRecurringServices,
} from '../../ducks';
import { AppState } from '../../../store';
import ReportIssueRecurringServicesModal from '../modal/ReportIssueRecurringServicesModal';

interface RouteParams {
  token: string;
}

interface ComponentProps extends RouteComponentProps<RouteParams> {
  account?: string;
  action?: number;
  confirmed?: string;
  customerName?: string;
  iconStatus?: string;
  locationName?: string;
  locationState?: string;
  locationZip?: string;
  loctionAddress?: string;
  loctionCity?: string;
  material?: string;
  quantity?: string;
  scheduledDate?: string;
  serviceDescr?: string;
  serviceFreq?: string;
  serviceType?: string;
  status?: string;
  svcOrd?: number;
  vendName?: string;
  vendorAddress?: string;
  vendorCity?: string;
  vendorState?: string;
  vendorZip?: string;
  workOrder: number;
  rateCodes: any;
  workOrderIdentifier: string;
  woTotal?: number;
}

interface Props extends ComponentProps {
  pricingInfo: any;
  issueType: any;
  vendorId: number;
  updateRecurringServices(...args: any[]): any;
  updateUndoReportRecurringServices(...args: any[]): any;
  updateUndoAcceptRecurringServices(...args: any[]): any;
  updateIssueReportRecurringServices(...args: any[]): any;
  reset(...args: any[]): any;
}

interface State {
  isAcceptRecurringServicesModalOpen: boolean;
  isReportIssueRecurringServicesModalOpen: boolean;
  isDetailsWorkOrderRateModalOpen: boolean;
}

const TableActionIconMock = TableActionIcon as any;
const PaymentInfoFillIconMock = PaymentInfoFillIcon as any;
const AcceptRecurringServicesModalMock = AcceptRecurringServicesModal as any;

class RecurringServicesFormTableRow extends PureComponent<Props, State> {
  readonly state = {
    isAcceptRecurringServicesModalOpen: false,
    isReportIssueRecurringServicesModalOpen: false,
    isDetailsWorkOrderRateModalOpen: false,
  };

  // Undo
  onUndoSubmit = async () => {
    const {
      vendorId,
      workOrder,
      scheduledDate,
      action,
      rateCodes,
      svcOrd,
      location,
      pricingInfo,
      match: {
        params: { token },
      },
    } = this.props;
    const { page } = getQueryParams(location.search);
    const requestRecurringServicesObj: any = {};

    requestRecurringServicesObj.workOrder = workOrder;
    requestRecurringServicesObj.svcOrd = svcOrd;
    requestRecurringServicesObj.date = moment(pricingInfo.reportDate).format('YYYY-MM-DD');

    if (action === 1) {
      requestRecurringServicesObj.rubiconInvoiceNo = pricingInfo.rubiconInvoiceNo;
      requestRecurringServicesObj.rateCodes = rateCodes;

      await this.props
        .updateUndoAcceptRecurringServices(requestRecurringServicesObj, vendorId, token, page, LIMIT_PER_PAGE)
        .then(() => {
          createSuccessNotification(translate('opportunity.opportunitySave'));
          //   onCancel(true);
        })
        .catch(() => {
          createErrorNotification(translate('opportunity.opportunitySaveError'));
        });
    } else if (action === 2) {
      requestRecurringServicesObj.scheduleDate = moment(scheduledDate).format('YYYY-MM-DD');

      await this.props
        .updateUndoReportRecurringServices(requestRecurringServicesObj, vendorId, token, page, LIMIT_PER_PAGE)
        .then(() => {
          createSuccessNotification(translate('opportunity.opportunitySave'));
          //   onCancel(true);
        })
        .catch(() => {
          createErrorNotification(translate('opportunity.opportunitySaveError'));
        });
    }
  };

  // Details
  openDetailsWorkOrderRateModalOpen = (event: any) => {
    this.setState({ isDetailsWorkOrderRateModalOpen: true });
    event.stopPropagation();

    return false;
  };

  closeDetailsWorkOrderRateModalOpen = () => {
    this.props.reset('acceptRecurringServices');
    this.setState({ isDetailsWorkOrderRateModalOpen: false });
  };

  // Accept
  openAcceptRecurringServicesModal = (event: any) => {
    this.setState({ isAcceptRecurringServicesModalOpen: true });
    event.stopPropagation();

    return false;
  };

  closeAcceptRecurringServicesModal = async (formPristine: boolean) => {
    if (!formPristine) {
      if (!(await confirm(translate('common.alertMessages.leavePageWithoutSaving')))) {
        return;
      }
    }

    this.props.reset('acceptRecurringServices');
    this.setState({ isAcceptRecurringServicesModalOpen: false });
  };

  // Report Issue
  openReportIssueRecurringServicesModal = () => {
    this.setState({ isReportIssueRecurringServicesModalOpen: true });
  };

  closeReportIssueRecurringServicesModal = async (formPristine: boolean) => {
    if (!formPristine) {
      if (!(await confirm(translate('common.alertMessages.leavePageWithoutSaving')))) {
        return;
      }
    }

    this.props.reset('reportIssueRecurringServices');
    this.setState({ isReportIssueRecurringServicesModalOpen: false });
  };

  render() {
    const {
      workOrderIdentifier,
      workOrder,
      account,
      customerName,
      vendName,
      vendorAddress,
      vendorCity,
      vendorState,
      vendorZip,
      locationName,
      loctionAddress,
      loctionCity,
      locationState,
      locationZip,
      confirmed,
      action,
      // businessType,
      serviceDescr,
      material,
      serviceType,
      serviceFreq,
      quantity,
      scheduledDate,
      status,
      woTotal,
      iconStatus,
      vendorId,
      rateCodes,
      location,
      match,
      updateIssueReportRecurringServices,
    } = this.props;

    const token = match.params.token;

    return (
      <TableRow key={workOrderIdentifier}>
        <TableCell vertical width="8%" padding="no no xSmall xSmall">
          {vendName && (
            <Fragment>
              <Text block weight="normal" margin="no no no" size="small">
                {status}
              </Text>
              <Text block weight="normal" margin="no no no" size="small">
                <TableActionIconMock icon={iconStatus} size="medium" />
              </Text>
            </Fragment>
          )}
        </TableCell>
        <TableCell vertical width="16%" padding="no xSmall xSmall xSmall">
          {vendName && (
            <Fragment>
              {/* <Text margin="no no no" size="small" singleLine color="gray">
                {customerName}
              </Text> */}
              <Text block weight="medium" margin="no no xxSmall" size="small">
                {vendName}
              </Text>
            </Fragment>
          )}
          {vendorAddress && (
            <Fragment>
              {/* <Text margin="no no no" size="small" singleLine color="gray">
                {translate('common.address')}:{' '}
              </Text> */}
              <Text block margin="no no xxSmall" weight="light" size="small">
                {` ${vendorAddress}, ${vendorCity}, ${vendorState}, ${vendorZip}`}
              </Text>
            </Fragment>
          )}
        </TableCell>
        <TableCell width="16%" vertical>
          {locationName && (
            <Fragment>
              <Text weight="normal" margin="no no xxSmall" size="small">
                {customerName} ({locationName})
              </Text>
            </Fragment>
          )}
          {loctionAddress && (
            <Text block margin="no no xxSmall" weight="light" size="small">
              {` ${loctionAddress}, ${loctionCity}, ${locationState}, ${locationZip}`}
            </Text>
          )}
        </TableCell>
        <TableCell width="12%" vertical>
          {workOrder && (
            <Fragment>
              <Text margin="no no no" size="small" singleLine color="gray">
                {translate('payment.rubiconWO')}:{' '}
              </Text>

              <Text margin="no no xxSmall" weight="normal" size="small" singleLine>
                {workOrder}
              </Text>
            </Fragment>
          )}
          {account && (
            <Fragment>
              <Text margin="no no no" size="small" singleLine color="gray">
                {translate('common.account')}:{' '}
              </Text>
              <Text margin="no no xxSmall" weight="normal" size="small" singleLine>
                {account}
              </Text>
            </Fragment>
          )}

          {!isFalsy(woTotal, { allowZero: true }) && (
            <Fragment>
              <Text margin="no no no" size="small" singleLine color="gray">
                {translate('payment.woTotal')}:{' '}
              </Text>
              <Text margin="no no no" weight="normal" size="small" singleLine>
                ${woTotal}
              </Text>
              <Text margin="no no no" weight="normal" size="small" singleLine>
                <PaymentInfoFillIconPopUpOpen onClick={this.openDetailsWorkOrderRateModalOpen}>
                  <Text margin="no no no" size="small" singleLine color="gray">
                    {translate('payment.details')}
                  </Text>
                  <PaymentInfoFillIconMock color="primary" margin="no no no" />
                </PaymentInfoFillIconPopUpOpen>
                {this.state.isDetailsWorkOrderRateModalOpen && (
                  <DetailsWorkOrderRateModal
                    workOrderIdentifier={workOrderIdentifier}
                    rateCodes={rateCodes}
                    onCancel={this.closeDetailsWorkOrderRateModalOpen}
                  />
                )}
              </Text>
            </Fragment>
          )}
        </TableCell>
        <TableCell vertical width="16%" padding="xSmall xSmall xSmall xSmall">
          {serviceDescr && (
            <Fragment>
              <Text margin="no no no" size="small" singleLine color="gray">
                {translate('payment.serviceDescription')}:{' '}
              </Text>
              <Text margin="no no xxSmall" weight="normal" size="small" singleLine>
                {serviceType}
              </Text>
              <Text margin="no no xxSmall" weight="normal" size="small" singleLine>
                {serviceDescr}
              </Text>
            </Fragment>
          )}
          {material && (
            <Fragment>
              {/* <Text margin="no no no" size="small" singleLine color="gray">
                {translate('common.material')}:{' '}
              </Text> */}
              <Text weight="normal" size="small" singleLine>
                {material}
              </Text>
            </Fragment>
          )}
          {serviceFreq && (
            <Fragment>
              {/* <Text margin="no no no" size="small" singleLine color="gray">
                {translate('opportunity.frequency')}:{' '}
              </Text> */}
              <Text weight="normal" size="small" singleLine>
                {serviceFreq}
              </Text>
            </Fragment>
          )}
          {quantity && (
            <Fragment>
              {/* <Text margin="no no no" size="small" singleLine color="gray">
                {translate('opportunity.quantity')}:{' '}
              </Text> */}
              <Text weight="normal" size="small" singleLine>
                {quantity}
              </Text>
            </Fragment>
          )}
          {scheduledDate && (
            <Fragment>
              <Text margin="no no no" size="small" singleLine color="gray">
                {translate('opportunity.scheduledDate')}:{' '}
              </Text>
              <Text weight="normal" size="small" singleLine>
                {scheduledDate}
              </Text>
            </Fragment>
          )}
        </TableCell>

        <TableCell vertical width="12%">
          {confirmed && (
            <Fragment>
              <Text margin="no no xxSmall" weight="normal" size="small" align="center   " singleLine>
                {confirmed}
              </Text>
            </Fragment>
          )}
        </TableCell>
        <TableCell vertical width="20%" padding="no no no no">
          <ButtonSet vertical flex-direction="column" align="center">
            {(action === 0 || action === 1 || action === 4) && (
              <Button
                background-color="transparent"
                color="primary"
                size="small"
                onClick={this.openAcceptRecurringServicesModal}
                disabled={action === 1}
                margin="no no xSmall"
              >
                {translate('accept')}
              </Button>
            )}
            {this.state.isAcceptRecurringServicesModalOpen && (
              <AcceptRecurringServicesModalMock {...this.props} onCancel={this.closeAcceptRecurringServicesModal} />
            )}
            {action === 1 && (
              <Button
                color="primary"
                background-color="transparent"
                size="small"
                onClick={this.onUndoSubmit}
                line
                margin="no no xSmall"
              >
                {translate('payment.undoAccept')}
              </Button>
            )}
            {action === 2 && (
              <Button
                color="primary"
                background-color="transparent"
                size="small"
                onClick={this.onUndoSubmit}
                line
                margin="no no xSmall"
              >
                {translate('payment.undo')}
              </Button>
            )}

            {(action === 0 || action === 2 || action === 4) && (
              <Button
                color="alert"
                background-color="transparent"
                size="small"
                onClick={this.openReportIssueRecurringServicesModal}
                line
                disabled={action === 0 || action === 2 || action === 4}
                margin="no no xSmall"
              >
                {translate('payment.reportIssue')}
              </Button>
            )}
            {this.state.isReportIssueRecurringServicesModalOpen && (
              <ReportIssueRecurringServicesModal
                workOrderIdentifier={workOrderIdentifier}
                workOrder={workOrder}
                vendorId={vendorId}
                action={action}
                scheduledDate={scheduledDate}
                updateIssueReportRecurringServices={updateIssueReportRecurringServices}
                onCancel={this.closeReportIssueRecurringServicesModal}
                token={token}
                location={location}
              />
            )}
          </ButtonSet>
          {action === 4 && (
            <Text margin="no no no" size="small" color="gray">
              {translate('payment.reportIssueMessage')}
            </Text>
          )}
        </TableCell>
      </TableRow>
    );
  }
}

// const formSelector = formValueSelector('recurringServicesForm');

const mapStateToProps = (state: AppState) => ({
  vendorId: currentVendorIdSelector(state.account.login, state.vendors.defaultVendor),
  pricingInfo: state.payments.recurringServices.pricingInfo,
  issueType: state.payments.recurringServices.issueType,
});

const mapDispatchToProps = {
  updateRecurringServices,
  updateUndoReportRecurringServices,
  updateUndoAcceptRecurringServices,
  updateIssueReportRecurringServices,
  reset,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecurringServicesFormTableRow));
